function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { j as e } from "./index.es33.js";
import { Icon as s } from "./index.es7.js";
import { PreloadIcon as r } from "./index.es8.js";
var o = {
    card: [s.icons.system.m.billing.creditCard, s.icons.system.m.billing.creditCardDisabled],
    expressCheckout: [s.icons.system.m.billing.expressCheckout, s.icons.system.m.billing.expressCheckoutDisabled],
    paypal: [s.icons.system.m.billing.paypal, s.icons.system.m.billing.paypalDisabled]
  },
  p = function p(_ref) {
    var n = _ref.isDisabled,
      i = _ref.kind;
    var _ref2 = n ? _toConsumableArray(o[i]).reverse() : o[i],
      _ref3 = _slicedToArray(_ref2, 2),
      t = _ref3[0],
      c = _ref3[1];
    return e.jsxs("div", {
      children: [e.jsx(s, {
        icon: t,
        size: 24
      }), e.jsx(r, {
        icon: c,
        size: 24
      })]
    });
  };
export { p as PaymentMethodIcon };